/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { attendanceServices } from '../../../../api/services/attendanceServices';
import {
  setEmpTimeSheetData,
  setTimeSheetLoader,
} from '../../../../infra/aggregates/myProfile/AttendanceAggregates/getEmpTimeSheetSlice';
import moment from 'moment';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import localStorage from 'redux-persist/es/storage';
import { useSelector } from 'react-redux';

interface PropsValues {
  setEmptimesheetDatas: (data: any) => void;
  year: any;
  month: any;
  fromdate: any;
  todate: any;
  setCount: (data: any) => void;
  pageSize: number;
  page: number;
}

function DTOTimeSheet({
  setEmptimesheetDatas,
  year,
  month,
  fromdate,
  todate,
  setCount,
  pageSize,
  page,
}: PropsValues) {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);
  const superadmin = useAppSelector((state) => state.isHRViewSlice.HRView);
  const state = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const adminId: any = useSelector(
    (state: any) => state?.adminIdSlice?.adminId,
  );

  async function getTimeSheetList(
    companyId: number,
    empId: number,
    pageSize = 10,
    page = 1,
  ) {
    const _todayDate = new Date();
    const _fromDate = fromdate
      ? fromdate
      : moment(_todayDate).format('YYYY-MM-DD');
    const _toDate = todate ? todate : '';
    const getCurrentMonth = moment(_todayDate).format('M');
    const _month = parseInt(getCurrentMonth);
    const getCurrentYear = moment(_todayDate).get('year');
    let isAdminView = 0;
    if (superadmin) {
      isAdminView = 1;
    }
    dispatch(setTimeSheetLoader(true));
    const response: any = await attendanceServices.getTimesheet(
      companyId,
      empId,
      getCurrentYear,
      _month,
      _fromDate,
      _toDate,
      pageSize,
      page,
      isAdminView,
      adminId,
    );
    if (response.status === 200) {
      setCount(response?.total_count);
      dispatch(setEmpTimeSheetData(response.data));
      const timesheetDataList: any = _.map(response.data, (data: any) => {
        const hourdata = data ? data?.hours_need : 0;
        const hourworked = data?.hours ? data?.hours : 0;
        const rowData: any = {
          id: data?.id,
          checkIn_checkOut: data?.check_in_check_outs,
          date: data?.date ? data?.date : '',
          clockIn: data?.clock_in ? data?.clock_in : '',
          clockout: data?.clock_out ? data?.clock_out : '',
          // hoursneed: t('{{count}} Hours', { count: hourdata }),
          hoursneed: `${data?.hours_need_interval?.d ?? '0'}d:${
            data?.hours_need_interval?.h ?? '0'
          }h:${data?.hours_need_interval?.i ?? '0'}m`,
          hoursworked: `${data?.total_hrs_interval?.d ?? '0'}d:${
            data?.total_hrs_interval?.h ?? '0'
          }h:${data?.total_hrs_interval?.i ?? '0'}m`,
          breakHours: `${data?.hours_with_breaktime_interval?.d ?? '0'}d:${
            data?.hours_with_breaktime_interval?.h ?? '0'
          }h:${data?.hours_with_breaktime_interval?.i ?? '0'}m`,
          // hoursworked: t('{{count}} Hours', { count: hourworked }),
          action: data?.status,
          timezoneOffset: data?.timezoneOffset,
        };
        return rowData;
      });
      setEmptimesheetDatas(timesheetDataList);
      dispatch(setTimeSheetLoader(false));
    } else {
      dispatch(setTimeSheetLoader(false));
      return;
    }
  }
  useEffect(() => {
    if (selector.emp_id && selector.company_id)
      getTimeSheetList(selector.company_id, selector.emp_id, pageSize);
  }, [fromdate, todate]);

  useEffect(() => {
    if (pageSize)
      getTimeSheetList(selector.company_id, selector.emp_id, pageSize);
  }, [pageSize]);

  useEffect(() => {
    if (page)
      getTimeSheetList(selector.company_id, selector.emp_id, pageSize, page);
  }, [page]);

  async function gettimesheetData(companyId: number, empId: number) {
    const _todayDate = new Date();
    dispatch(setTimeSheetLoader(true));
    const response: any = await attendanceServices.getTimesheet(
      companyId,
      empId,
      year,
      month,
    );

    if (response.status === 200) {
      dispatch(setEmpTimeSheetData(response.data));
      const timesheetDataList: any = _.map(response.data, (data: any) => {
        const hoursneed = data ? data?.hours_need : 0;
        const hoursworked = data ? data?.hours : 0;
        const rowData: any = {
          id: data?.id,
          checkIn_checkOut: data?.check_in_check_outs,
          date: data?.date ? data?.date : '',
          clockIn: data?.clock_in ? data?.clock_in : '-- --',
          clockout: data?.clock_out ? data?.clock_out : '-- --',
          hoursneed: t('{{count}} Hours', { count: hoursneed }),
          hoursworked: t('{{count}} Hours', { count: hoursworked }),
          action: data?.status,
        };
        return rowData;
      });
      setEmptimesheetDatas(timesheetDataList);
      dispatch(setTimeSheetLoader(false));
    } else {
      dispatch(setTimeSheetLoader(false));
      return;
    }
  }
  //timesheet

  useEffect(() => {
    if (month && year != 0)
      gettimesheetData(selector.company_id, selector.emp_id);
  }, [year, month]);

  return <></>;
}
export default DTOTimeSheet;
